export const USER_SESSION_STORAGE_KEY = "bsedu:userSession"
export const LEGACY_ACCESS_TOKEN_KEY = "accessToken"

function getDefaultStorage() {
    return typeof localStorage === "undefined" ? null : localStorage
}

function normalizeToken(value) {
    if (!value || value === "null" || value === "undefined") return ""
    return value
}

function normalizeSession(session) {
    if (!session || typeof session !== "object") return null

    const accessToken = normalizeToken(session.accessToken)
    if (!accessToken) return null

    return {
        user: session.user,
        accessToken,
        refreshToken: session.refreshToken || "",
        tokenType: session.tokenType || "Bearer",
        ...(Number.isFinite(session.logoutAt) && session.logoutAt > 0 ? { logoutAt: session.logoutAt } : {}),
    }
}

export function readUserSession(storage = getDefaultStorage()) {
    if (!storage) return null

    try {
        const storedSession = storage.getItem(USER_SESSION_STORAGE_KEY)
        if (storedSession) {
            const session = normalizeSession(JSON.parse(storedSession))
            if (session) return session

            storage.removeItem(USER_SESSION_STORAGE_KEY)
        }

        const legacyAccessToken = normalizeToken(storage.getItem(LEGACY_ACCESS_TOKEN_KEY))
        if (legacyAccessToken) {
            storage.removeItem(LEGACY_ACCESS_TOKEN_KEY)
        }
    } catch {
        try {
            storage.removeItem(USER_SESSION_STORAGE_KEY)
        } catch {
            return null
        }
    }

    return null
}

export function writeUserSession(payload, storage = getDefaultStorage()) {
    if (!storage) return

    const session = normalizeSession({
        user: payload?.loginUser?.user ?? payload?.user,
        accessToken: payload?.accessToken,
        refreshToken: payload?.refreshToken,
        tokenType: payload?.tokenType,
        logoutAt: payload?.logoutAt,
    })

    if (!session) return

    storage.setItem(USER_SESSION_STORAGE_KEY, JSON.stringify(session))
    storage.setItem(LEGACY_ACCESS_TOKEN_KEY, session.accessToken)
}

export function clearUserSession(storage = getDefaultStorage()) {
    if (!storage) return

    storage.removeItem(USER_SESSION_STORAGE_KEY)
    storage.removeItem(LEGACY_ACCESS_TOKEN_KEY)
}
